export const ProductionTypeFelling = 1
export const ProductionTypeRoadDelivery = 2
export const ProductionTypeFellingAndDelivery = 3

/** Estimated amount of time needed for CRM to sync changes related to production orders to VH  */
export const MS_DELAY_CRM_TO_VH_SYNC = 1000 /*ms*/ * 60 /*seconds*/ * 2 /*minutes*/

/** Interval for running cleanup-routine, clearing old entries */
export const MS_INTERVAL_CLEAN_MODIFIED_TIMESTAMPS = 1000 /*ms*/ * 60 /*seconds*/ * 5 /*minutes*/
